import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Trans } from '@common/i18n/trans';
export function TwoFactorStepperLayout({ title, subtitle, description, actions, children, }) {
    if (!subtitle) {
        subtitle = (_jsx(Trans, { message: "When two factor authentication is enabled, you will be prompted for a secure, random token during authentication. You may retrieve this token from your phone's Google Authenticator application." }));
    }
    return (_jsxs(Fragment, { children: [_jsx("div", { className: "text-base font-medium mb-16", children: title }), _jsx("div", { className: "text-sm mb-24", children: subtitle }), _jsx("p", { className: "text-sm font-medium my-16", children: description }), children, _jsx("div", { className: "flex items-center gap-12", children: actions })] }));
}
